// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getUpdateMachineStatusHistoryColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerClassName,
            headerName: translate('MODEL'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'processingStatus',
            field: 'processingStatus',
            headerClass: classNames.headerClassName,
            headerName: translate('PROCESSING_STATUS'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'statusText',
            field: 'statusText',
            headerClass: classNames.headerClassName,
            headerName: translate('MACHINE_STATUS'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'currentDealerId',
            field: 'currentDealerId',
            headerClass: classNames.headerClassName,
            headerName: translate('CURRENT_ACCOUNT'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'currentDealerName',
            field: 'currentDealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CURRENT_DEALER'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'creationDate',
            field: 'creationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CREATED'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'createdBy',
            field: 'createdBy',
            headerClass: classNames.headerClassName,
            headerName: translate('CREATED_BY'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'changedOn',
            field: 'changedOn',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CHANGED_ON'),
            width: 140
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'changedBy',
            field: 'changedBy',
            headerClass: classNames.headerClassName,
            headerName: translate('CHANGED_BY'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerComments',
            field: 'dealerComments',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_COMMENTS'),
            width: 250
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'deereRemarks',
            field: 'deereRemarks',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEERE_REMARKS'),
            width: 250
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/report-services/column-definitions.js